export const cilSquare = ["24 24","<path d='M22.313 0.75h-20.625c-0.518 0.001-0.937 0.42-0.938 0.937v20.625c0.001 0.518 0.42 0.937 0.937 0.938h20.625c0.518-0.001 0.937-0.42 0.938-0.937v-20.625c-0.001-0.518-0.42-0.937-0.937-0.938h-0zM21.75 21.75h-19.5v-19.5h19.5z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-square.js
// module id = null
// module chunks = 